// Route quản trị cũ của Ezy → HANA Kit (QĐ anh David 01/Nov: quản trị tách khỏi Ezy sang /kit; route cũ giữ redirect).
// Hub áp bảng này trong beforeLoad của vùng (apps/hub/src/zones.tsx).
//
// `live: false` = màn cũ còn chạy trong Ezy (luồng H chuyển sang Kit sáng 02/Nov) và đang là cặp gate của luồng H
// (pairs/h.json: /ezy/admin · /ezy/roles · /ezy/action-log · /ezy/webadmin). Bật redirect sớm sẽ làm mất màn đang chạy và làm đỏ
// cổng của luồng khác — H đổi `live: true` trong cùng PR chuyển màn + đổi route cặp gate sang /kit/….
// Đường dẫn chưa từng có màn (m365, zalo-oa, web-admin) chuyển ngay.

export interface LegacyRoute {
  from: string;
  to: string;
  live: boolean;
}

export const LEGACY: readonly LegacyRoute[] = [
  { from: '/ezy/admin', to: '/kit', live: true },
  { from: '/ezy/roles', to: '/kit/roles', live: true },
  { from: '/ezy/action-log', to: '/kit/action-log', live: true },
  { from: '/ezy/webadmin', to: '/kit/web-admin', live: true },
  { from: '/ezy/web-admin', to: '/kit/web-admin', live: true },
  { from: '/ezy/m365', to: '/kit/m365', live: true },
  { from: '/ezy/zalo-oa', to: '/kit/zalo-oa', live: true },
];

const trim = (p: string) => (p.length > 1 ? p.replace(/\/+$/, '') : p);

/** Đường dẫn mới trong Kit nếu `path` là route quản trị cũ đã chuyển (khớp nguyên đoạn, giữ phần đuôi `/…`); không thì null. */
export function kitRedirect(path: string, all = false): string | null {
  const p = trim(path);
  for (const r of LEGACY) {
    if (!r.live && !all) continue;
    if (p === r.from) return r.to;
    if (p.startsWith(r.from + '/')) return r.to + p.slice(r.from.length);
  }
  return null;
}
